import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyDaFJqL2PbmjgxQ_F2juxT_3PNYQzKYOS0",
    authDomain: "kingcab-20ff6.firebaseapp.com",
    databaseURL: "https://kingcab-20ff6.firebaseio.com",
    projectId: "kingcab-20ff6",
    storageBucket: "kingcab-20ff6.firebasestorage.app",
    messagingSenderId: "876966640038",
    appId: "1:876966640038:web:15861ac941604f48d8f767",
    measurementId: "G-0TR7ZQJ6LT"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)





